<template>
    <div>
        <button v-if="!isEdit" type="submit" class="ladda-button btn btn-primary"
                data-app-plugin="ladda" data-style="expand-left"
                @click="loadStudents">
            Fetch Students
        </button>

        <div class="alert alert-danger mt-10 mb-30" role="alert"
             v-show="hasErrors()">
            <b>Please correct the following errors:</b>
            <ul>
                <li v-for="error in errorsList">{{ error }}</li>
            </ul>
        </div>

        <div v-if="data?.students?.length > 0" class="mt-30">

            <table id="lesson-evaluation-form" class="table data-table dataTable table-bordered table-striped table-responsive border-0">
                <tbody>
                <tr>
                    <td class="hidden-sm-down" v-if="data.has_groups" rowspan="2">Group</td>
                    <td class="hidden-sm-down" rowspan="2">ID</td>
                    <td class="hidden-sm-down" rowspan="2">Roll</td>
                    <td rowspan="2">Name</td>
                    <td class="w-80" rowspan="2">Learned</td>
                    <td class="w-80" rowspan="2">Partially Learned</td>
                    <td class="w-80" rowspan="2">Didn't Learn</td>
                    <td class="w-80" rowspan="2">Absent</td>
                    <td colspan="3">Concentration</td>
                </tr>
                <tr>
                    <td class="w-80">Excellent</td>
                    <td class="w-80">Satisfactory</td>
                    <td class="w-80">Needs Improvement</td>
                </tr>
                <tr v-for="(student, index) in data.students" :key="index">
                    <td class="hidden-sm-down text-capitalize text-center" v-if="data.has_groups">{{ student.group_name }}</td>
                    <td class="hidden-sm-down">{{ student.display_id }}</td>
                    <td class="hidden-sm-down text-center">{{ student.roll }}</td>
                    <td class="text-left">
                        <div class="text-primary">{{ student.name }}</div>
                        <small class="hidden-md-up text-secondary">
                            <span class="d-block text-capitalize" v-if="data.has_groups">
                                {{ student.group_name }}
                            </span>
                            ID: {{ student.display_id }}
                            <span class="d-block" v-if="student.roll">
                                Roll: {{ student.roll }}
                            </span>
                        </small>
                    </td>
                    <td>
                        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-success">
                            <input :id="`learned-${index}`"
                                   type="radio" title="Learned"
                                   :name="`evaluation-${index}`"
                                   v-model="data.students[index].evaluation.status"
                                   value="learned"/>
                            <label :for="`learned-${index}`"></label>
                        </div>
                    </td>
                    <td>
                        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-warning">
                            <input :id="`partially-learned-${index}`"
                                   type="radio" title="Partially Learned"
                                   :name="`evaluation-${index}`"
                                   v-model="data.students[index].evaluation.status"
                                   value="partially_learned"/>
                            <label :for="`partially-learned-${index}`"></label>
                        </div>
                    </td>
                    <td>
                        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-danger">
                            <input :id="`didnt-learn-${index}`"
                                   type="radio" title="Didn't Learn"
                                   :name="`evaluation-${index}`"
                                   v-model="data.students[index].evaluation.status"
                                   value="didnt_learn"/>
                            <label :for="`didnt-learn-${index}`"></label>
                        </div>
                    </td>
                    <td>
                        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-primary">
                            <input :id="`absent-${index}`"
                                   type="radio" title="Absent"
                                   :name="`evaluation-${index}`"
                                   v-model="data.students[index].evaluation.status"
                                   value="absent"/>
                            <label :for="`absent-${index}`"></label>
                        </div>
                    </td>
                    <td>
                        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-success">
                            <input :id="`excellent-${index}`"
                                   type="radio" title="Excellent"
                                   :name="`concentration-${index}`"
                                   v-model="data.students[index].evaluation.concentration"
                                   value="excellent"/>
                            <label :for="`excellent-${index}`"></label>
                        </div>
                    </td>
                    <td>
                        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-warning">
                            <input :id="`satisfactory-${index}`"
                                   type="radio" title="Satisfactory"
                                   :name="`concentration-${index}`"
                                   v-model="data.students[index].evaluation.concentration"
                                   value="satisfactory"/>
                            <label :for="`satisfactory-${index}`"></label>
                        </div>
                    </td>
                    <td>
                        <div class="abc-checkbox abc-checkbox-circle abc-checkbox-primary">
                            <input :id="`needs-improvement-${index}`"
                                   type="radio" title="Satisfactory"
                                   :name="`concentration-${index}`"
                                   v-model="data.students[index].evaluation.concentration"
                                   value="needs_improvement"/>
                            <label :for="`needs-improvement-${index}`"></label>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <button type="submit" class="ladda-button btn btn-primary mt-20"
                    data-app-plugin="ladda" data-style="expand-left"
                    @click="submitEvaluation">
                Submit
            </button>

        </div>
    </div>
</template>

<script>
import {ref} from 'vue';
import FormElement from '../../components/FormElement';

export default {
    components: {
        FormElement,
    },
    props: {
        studentListUrl: {
            type: String,
            required: true,
        },
        recordCreateUrl: {
            type: String,
            required: true,
        },
        recordSubmitUrl: {
            type: String,
            required: true,
        },
        recordUpdateUrl: {
            type: String,
            required: true,
        },
        recordDetailsUrl: {
            type: String,
            required: true,
        },
        isEdit: {
            type: Boolean,
            required: true,
        },
        record: {
            type: Object,
            required: true,
        },
    },
    setup() {
        return {
            data: ref({
                session: null,
                branch: null,
                shift: null,
                class: null,
                section: null,
                group_name: null,
                subject: null,
                hasGroups: false,
                evaluation_date: null,
                evaluation_id: null,
                students: [],
            }),
            errors: ref({
                status: [],
                concentration: [],
            }),
            errorsList: ref([]),
        }
    },
    methods: {
        initialErrorsState() {
            return {
                status: [],
                concentration: [],
            }
        },
        onEvaluationChange(index) {
            this.data.students[index].evaluation = {
                status: document.querySelector(`input[name="evaluation-${index}"]:checked`)?.value
            }
        },
        async loadStudents() {
            let params = new URLSearchParams()
            params.append('session', document.querySelector('#session').value)
            params.append('branch', document.querySelector('#branch').value)
            params.append('shift', document.querySelector('#shift').value)
            params.append('class', document.querySelector('#class').value)
            params.append('section', document.querySelector('#section').value)
            params.append('subject', document.querySelector('#subject').value)
            params.append('evaluation_date', document.querySelector('#evaluation_date').value)

            if (!this.validateRequiredFields(params)) {
                this.stopLoaders()

                return
            }

            let json;

            const response = await fetch(
                `${this.studentListUrl}?${params}`,
                {
                    method: 'get',
                    headers: new Headers({
                        'X-Requested-With': 'XMLHttpRequest',
                    }),
                    credentials: 'include'  // adds cookie header
                }
            )
            if (response.status === 422) {
                const json = await response.json()
                console.log(json)
            } else if (!response.ok) {
                const error = await response.text()
                toastr.error(`Failed fetching student list: ${error}`)
            } else {
                json = await response.json()

                for (let i = 0; i < json.data.students.length; i++) {
                    if (!json.data.students[i].evaluation) {
                        json.data.students[i].evaluation = {
                            status: json.data.students[i].attendance === 'absent' ? 'absent' : 'learned',
                            concentration: 'excellent'
                        }
                    }
                }

                this.data = json.data
            }

            this.stopLoaders()

            this.$nextTick(() => {
                window.goToNextRowSameColumnInputOnEnter('vertical')
                window.disableMouseWheelOnNumberInputs()
                Ladda.bind('.ladda-button')
            }).then(() => {})
        },
        validateRequiredFields(formData) {
            let fieldLabels = {
                session: 'Session',
                branch: 'Branch',
                shift: 'Shift',
                class: 'Class',
                section: 'Section',
                subject: 'Subject',
                evaluation_date: 'Date',
            }

            for (let field of Object.keys(fieldLabels)) {
                if (!formData.get(field)) {
                    toastr.error(`Please select a ${fieldLabels[field]}.`);

                    return false
                }
            }

            return true;
        },
        stopLoaders() {
            setTimeout(() => window.Ladda.stopAll(), 500)
        },
        hasErrors() {
            return this.errorsList.length > 0
        },
        async submitEvaluation() {
            this.clearErrors()

            if (this.isEdit) {
                this.data.session = document.querySelector('#session').value
                this.data.section = document.querySelector('#section').value
                this.data.subject = document.querySelector('#subject').value
                this.data.evaluation_date = document.querySelector('#evaluation_date').value
            }

            const formData = {
                'evaluation_id': this.data.evaluation_id || null,
                'session': this.data.session || null,
                'section': this.data.section || null,
                'subject': this.data.subject || null,
                'evaluation_date': this.data.evaluation_date || null,
                'data': this.data.students,
            }

            const response = await fetch(
                this.isEdit ? this.recordUpdateUrl : this.recordSubmitUrl,
                {
                    method: 'post',
                    body: JSON.stringify(formData),
                    headers: new Headers({
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    }),
                    credentials: 'include'  // adds cookie header
                }
            )
            if (response.status === 422) {
                const json = await response.json()
                this.showSubmissionErrors(this.transformSubmissionErrors(json.errors))
            } else if (!response.ok) {
                const error = await response.text()
                toastr.error(`Failed saving evaluation records: ${error}`)
            } else {
                toastr.success('Lesson Evaluation recorded successfully')
                if (this.isEdit) {
                    window.location = this.recordDetailsUrl.replace('0', this.record.id)
                } else {
                    window.location = `${this.recordCreateUrl}?`
                        + `session=${this.data.session}&`
                        + `branch=${this.data.branch}&`
                        + `shift=${this.data.shift}&`
                        + `class=${this.data.class}&`
                        + `section=${this.data.section}&`
                        + `subject=${this.data.subject}&`
                        + `evaluation_date=${this.data.evaluation_date}&`
                }
            }

            this.stopLoaders()
        },
        transformSubmissionErrors(serverSideErrors) {
            const errors = this.initialErrorsState()
            let errorsList = []

            for (let prop in serverSideErrors) {
                const propParts = prop.split('.')
                if (propParts.length === 2) {
                    errors[propParts[0]][propParts[1]] = serverSideErrors[prop][0]
                } else {
                    errors[prop] = serverSideErrors[prop][0]
                }

                errorsList.push(serverSideErrors[prop][0])
            }

            this.errorsList = errorsList

            return errors
        },
        showSubmissionErrors(errors) {
            console.log(errors)
            this.errors = errors
            toastr.error(`Please correct the errors specified.`)
            window.scrollTo({top: 0, behavior: 'smooth'})
        },
        clearErrors() {
            this.errors = this.initialErrorsState()
            this.errorsList = []
        }
    },
    mounted() {
        if (this.isEdit) {
            this.data.evaluation_id = this.record.id
            this.data.session = this.record.session_id
            this.data.branch = this.record.section.branch_id
            this.data.shift = this.record.section.shift_id
            this.data.class = this.record.section.class_id
            this.data.section = this.record.section_id
            this.data.subject = this.record.subject_id
            this.data.evaluation_date = this.record.evaluation_date
            this.data.students = this.record.data.students
            this.data.has_groups = this.data.students.filter(student => student.group_name !== null).length > 0

            Ladda.bind('.ladda-button')
        }
    },
}
</script>

<style scoped>
    #lesson-evaluation-form th,
    #lesson-evaluation-form td {
        vertical-align: middle;
        text-align: center;
    }

    #lesson-evaluation-form tr:nth-child(1), tr:nth-child(2) td {
        background-color: #4E9EFF;
        border-top: 1px solid #3E8EF7 !important;
        border-bottom: 1px solid #3E8EF7 !important;
        color: #FFF !important;
        font-size: 16px;
        font-weight: 500!important;
    }

    #lesson-evaluation-form .abc-checkbox {
        margin-top: -20px;
        padding-left: 12px;
    }
    #lesson-evaluation-form .abc-checkbox label:after {
        padding-left: 0;
    }
</style>
